import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

export const Lightbox = ({ item, onClose }) => {
  useEffect(() => {
    if (!item) return undefined;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [item, onClose]);

  if (!item) return null;
  return createPortal(
    <div className="fixed inset-0 z-[110] flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label={item.caption} data-testid="lightbox">
      <div className="absolute inset-0 bg-black/90 backdrop-blur-sm" onClick={onClose} data-testid="lightbox-backdrop" aria-hidden="true" />
      <button type="button" onClick={onClose} aria-label="Close" className="absolute right-3 top-3 z-10 grid h-11 w-11 place-items-center rounded-full border border-[rgba(232,184,74,0.5)] bg-black/70 text-[var(--gold)] transition-colors hover:bg-black" data-testid="lightbox-close-button">
        <X className="h-5 w-5" />
      </button>
      <figure className="fade-up relative z-[1] flex max-h-full max-w-3xl flex-col items-center">
        <img src={item.src} alt={item.caption} className="max-h-[80vh] w-auto max-w-full rounded-lg border border-[rgba(232,184,74,0.5)] object-contain" data-testid="lightbox-image" />
        <figcaption className="mt-3 text-center text-sm text-[#e9e2d2]" data-testid="lightbox-caption">{item.caption}</figcaption>
      </figure>
    </div>,
    document.body
  );
};
